import { Routes, Route } from 'react-router-dom';
import { WorkDashboard } from './WorkDashboard';
import { ProjectList } from './projects/ProjectList';
import { ProjectDetail } from './projects/ProjectDetail';
import { CreateProject } from './projects/CreateProject';
import { TaskBoard } from './tasks/TaskBoard';
import { TaskDetail } from './tasks/TaskDetail';
import { SprintManagement } from './sprints/SprintManagement';
import { Whiteboard } from './whiteboard/Whiteboard';
import { ResourceManagement } from './resources/ResourceManagement';
import { DevOpsDashboard } from './devops/DevOpsDashboard';
import { ProjectFinance } from './finance/ProjectFinance';
import { IncidentManagement } from './incidents/IncidentManagement';
import { Timesheets } from './timesheets/Timesheets';
import { PlaceholderPage } from '../../components/PlaceholderPage';
import { GanttChart } from './gantt/GanttChart';
import { WorkCalendar } from './calendar/WorkCalendar';
import { Meetings } from './meetings/Meetings';
import { WorkDocuments } from './documents/WorkDocuments';
import { Notes } from './notes/Notes';
import { Workflows } from './workflows/Workflows';
import { Automation } from './automation/Automation';
import { Approvals } from './approvals/Approvals';
import { AiWorkAssistant } from './ai/AiWorkAssistant';
import { WorkReports } from './reports/WorkReports';
import { WorkSettings } from './settings/WorkSettings';
import React from 'react';
import { RequirePermissionRoute } from '../../components/RequirePermissionRoute';

/** Wrap a route element in a Work permission guard (fails open when perms unknown). */
const g = (el: React.ReactNode, resource: string, action = 'View') => (
  <RequirePermissionRoute moduleName="Work" resource={resource} action={action}>
    {el}
  </RequirePermissionRoute>
);

export function WorkHub() {
  return (
    <div className="work-hub">
      <Routes>
        <Route index element={<WorkDashboard />} />
        {/* Core Project Management */}
        <Route path="/projects" element={g(<ProjectList />, 'Projects')} />
        <Route path="/projects/new" element={g(<CreateProject />, 'Projects', 'Create')} />
        <Route path="/projects/:id" element={g(<ProjectDetail />, 'Projects')} />

        {/* Tasks and Agile */}
        <Route path="/tasks" element={g(<TaskBoard />, 'Tasks')} />
        <Route path="/tasks/:id" element={g(<TaskDetail />, 'Tasks')} />
        <Route path="/kanban" element={g(<TaskBoard />, 'Tasks')} />
        <Route path="/sprints" element={g(<SprintManagement />, 'Sprints')} />
        <Route path="/timesheets" element={g(<Timesheets />, 'Timesheets')} />

        {/* Collaboration */}
        <Route path="/whiteboard" element={g(<Whiteboard />, 'Whiteboards')} />

        {/* Resources & Finance */}
        <Route path="/resources" element={g(<ResourceManagement />, 'Resources')} />
        <Route path="/planner" element={g(<ResourceManagement />, 'Resources')} />
        <Route path="/finance" element={g(<ProjectFinance />, 'Finance')} />

        {/* DevOps & Incidents */}
        <Route path="/devops" element={g(<DevOpsDashboard />, 'DevOps')} />
        <Route path="/incidents" element={g(<IncidentManagement />, 'Incidents')} />

        {/* Cross-cutting + collaboration */}
        <Route path="/gantt" element={g(<GanttChart />, 'Projects')} />
        <Route path="/calendar" element={g(<WorkCalendar />, 'Meetings')} />
        <Route path="/meetings" element={g(<Meetings />, 'Meetings')} />
        <Route path="/documents" element={g(<WorkDocuments />, 'Documents')} />
        <Route path="/notes" element={g(<Notes />, 'Notes')} />
        <Route path="/approvals" element={g(<Approvals />, 'Approvals')} />
        <Route path="/reports" element={g(<WorkReports />, 'Reports')} />
        <Route path="/settings" element={g(<WorkSettings />, 'Settings')} />

        {/* Deferred greenfield engines — open (no backing resource yet) */}
        <Route path="/workflows" element={<Workflows />} />
        <Route path="/automation" element={<Automation />} />
        <Route path="/ai" element={<AiWorkAssistant />} />
      </Routes>
    </div>
  );
}
